import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalActions } from 'core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

interface ServerError {
    message: string;
}
/**
 * Интерцептор для обработки ошибки 500 Internal Server Error
 */
@Injectable()
export class DisplayServerErrorInterceptor implements HttpInterceptor {
    public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            catchError(err => {
                if (this.isInternalServerError(err)) {
                    try {
                        GlobalActions.displayError(this.getErrorMessage(err), GlobalActions.InfiniteInterval);
                    } catch (e) {
                        return throwError(e.message);
                    }
                }
                return throwError(err);
            })
        );
    }

    private isInternalServerError(error: HttpErrorResponse): boolean {
        /**
         * Если в качестве ошибки прилетает обычная html страница, то такие случаи мы не обрабатываем.
         * Нас интересуют только json ответы.
         */
        if (error.error) {
            if (error.error.length && error.error.startsWith && error.error.startsWith('<')) {
                return false;
            }
        }
        return error instanceof HttpErrorResponse && error.status === 500;
    }

    private getErrorMessage(error: HttpErrorResponse): string {
        if (typeof error.error === 'string') {
            try {
                return (JSON.parse(error.error) as ServerError).message;
            } catch {
                return error.error;
            }
        } else {
            return error.error.message;
        }
    }
}
